import SendAsset from './SendAsset';

export default SendAsset;
